import React, { useEffect, useState } from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Button, Form, FormGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { apiBaseURL } from "../../Common/ApiHelper";
import axios from "axios";

const stripePromise = loadStripe(
  "pk_live_51NNfFMBGWbhY74YkMjrBAM4n7E05hYYx6PYb6Dw17u09o7mj6om6AOq90fyVMCPNQxznE1TDmALnc3haaaUtcgNf00zAB0vVgB"
  // "pk_test_51NNfFMBGWbhY74Yk0xOP1Iizz0cFQu8ZYTLxW26RMxBG2gK32lxPNu9KXsOJoCOjnO0dDYc5Fpvwrbz5SqJL0DBX00OWDAELKf"
  // "pk_test_51LEmQYSJvTK5MWm5ggwnpgR5SgzPCK4n4EiZpBWZCyOLHA5NvHTBbksnbjgSSVspp6RMDY4ek073TGxJL1nZf6xE00s7gpSnkQ"
);

const CheckoutForm = (props) => {
  const [payableBtn, setPayableBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [termChecked, setTermChecked] = useState(false);
  const [checkedError, setCheckedError] = useState(false);

  const [loading, setLoading] = useState(false);

  const [currency, setCurrency] = useState("USD");
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      if (props?.props?.checkoutValuesPayload) {
        const {
          firstName,
          lastName,
          email,
          confirmEmail,
          password,
          confirmPassword,
          mobile,
          streetAddress,
          state,
          city,
          country,
        } = props?.props?.checkoutValuesPayload;
        const disablePayBtn = !!!(
          firstName &&
          lastName &&
          email &&
          confirmEmail &&
          password &&
          confirmPassword &&
          mobile?.length === 10 &&
          streetAddress &&
          city &&
          state &&
          country &&
          email === confirmEmail &&
          password === confirmPassword
        );
        setBtnDisable(disablePayBtn);
      } else {
        setBtnDisable(true);
      }
    } else {
      if (props?.props?.checkoutValuesPayload) {
        const {
          firstName,
          lastName,
          email,
          mobile,
          streetAddress,
          state,
          city,
          country,
        } = props?.props?.checkoutValuesPayload;
        const disablePayBtn = !!!(
          firstName &&
          lastName &&
          email &&
          mobile?.length === 10 &&
          state &&
          streetAddress &&
          city &&
          country
        );
        setBtnDisable(disablePayBtn);
      } else {
        setBtnDisable(true);
      }
    }
  }, [props?.props?.checkoutValuesPayload]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });
    if (termChecked) {
      setLoading(true);
      if (!error) {
        const { id: source } = paymentMethod;
        const response = await fetch(`${apiBaseURL}service/payment`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: (props?.props?.payableAmount).toFixed(2),
            currency,
            source,
            CardElement,
            userDetails: props?.props?.checkoutValuesPayload,
            appliedCoupon: props?.props?.couponCode,
            userCart: props?.props?.userCart,
            paymentMethod: paymentMethod,
            email: props?.props?.checkoutValuesPayload.email,
            user: {
              email: props?.props?.checkoutValuesPayload.email,
              name: `${props?.props?.checkoutValuesPayload?.firstName} ${props?.props?.checkoutValuesPayload?.lastName}`,
            },
          }),
        });
        const data = await response.json();
        if (data.statusCode === 200) {
          // Payment succeeded, handle fulfillment and redirect to success page
          // stripe.confirmCardPayment(data.data.clientSecret, {
          //   payment_method: {
          //     card: elements.getElement(CardElement),
          //     // You can also pass additional payment method options here, such as mandate_options for SEPA Direct Debit
          //   },
          // });
          setLoading(false);
          paymentStatusPaid(paymentMethod, data);
        } else {
          // Handle error
          setLoading(false);
          paymentStatusUnPaid(paymentMethod, data);
        }
      }
    } else setCheckedError(true);
  };
  const paymentStatusUnPaid = async (paymentMethod, data) => {
    try {
      const response = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: `${apiBaseURL}service/paymentStatus`,
        data: JSON.stringify({
          _id: data?.data?._doc?._id,
          status: "UNPAID",
          amount: (props?.props?.payableAmount).toFixed(2),
          userDetails: props?.props?.checkoutValuesPayload,
          appliedCoupon: props?.props?.couponCode,
          userCart: props?.props?.userCart,
          paymentMethod: paymentMethod,
          email: props?.props?.checkoutValuesPayload.email,
        }),
      });
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.error);
    }
  };
  const paymentStatusPaid = async (paymentMethod, data) => {
    try {
      const response = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: `${apiBaseURL}service/paymentStatus`,
        data: JSON.stringify({
          _id: data?.data?._doc?._id,
          status: "PAID",
          amount: (props?.props?.payableAmount).toFixed(2),
          userDetails: props?.props?.checkoutValuesPayload,
          appliedCoupon: props?.props?.couponCode,
          userCart: props?.props?.userCart,
          paymentMethod: paymentMethod,
          email: props?.props?.checkoutValuesPayload.email,
        }),
      });
      if (response?.data?.statusCode === 200) {
        if (!localStorage.getItem("token")) {
          props?.props?.setUserDetails(response?.data?.data?.userData);
          localStorage.setItem(
            "userData",
            JSON.stringify(response?.data?.data?.userData)
          );
          localStorage.setItem(
            "token",
            JSON.stringify(response?.data?.data?.userData?.accessToken)
          );
        }
        localStorage.removeItem("cartItems");
        localStorage.removeItem("Usercart");
        localStorage.removeItem("addedProducts");
        navigate(`/order_summary`);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.error);
    }
  };
  return (
    <>
      <ToastContainer />
      <h2 className="blue_bg text-white mb-0 mt-3">Purchase Option</h2>
      <div className="billing_information purchase_option mb-2">
        <form
          onSubmit={handleSubmit}
          style={{
            padding: "2rem 0",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <CardElement
            className="checkout_input"
            onChange={(e) => {
              setPayableBtn(e.complete);
            }}
          />
          <FormGroup>
            <Form.Check
              type="checkbox"
              id="purchaseTerm&Conditions"
              label={
                <div>
                  <span>I have read and agree to the website</span>
                  <a href="/terms" target="_blank" rel="noopener noreferrer">
                    {" "}
                    terms and conditions *
                  </a>
                </div>
              }
              checked={termChecked}
              onChange={() => {
                if (termChecked) {
                  setTermChecked(false);
                } else {
                  setTermChecked(true);
                  setCheckedError(false);
                }
              }}
            />
            {checkedError ? (
              <span style={{ color: "red" }}>Terms must be accepted</span>
            ) : null}

            <p className="info_security_text">
              Your personal information is used securely and temporarily by our
              merchant provider to process your order. <br />
              Your card data is not stored or used by Libertysoftware.com
            </p>
          </FormGroup>
          {btnDisable ? (
            <span style={{ color: "red" }}>
              Please fill the required fields.
            </span>
          ) : null}
          <Button
            className="place_order_btn"
            type="submit"
            disabled={!stripe || !payableBtn || btnDisable}
          >
            {loading ? (
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              ""
            )}
            Place Order {""}
            <span className="order_amount">
              {Number(
                props?.props?.payableAmount
                  ? props?.props?.payableAmount
                  : props?.props?.salePrice
              ).toFixed(2)}{" "}
            </span>
            USD
          </Button>
        </form>
      </div>
    </>
  );
};

const Payment = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm props={props} />
    </Elements>
  );
};

export default Payment;
